import React, { useContext } from 'react';
import { Box, Button, Fade, Popper, Stack, Typography } from '@mui/material';
import { AiFillInfoCircle } from 'react-icons/ai';
import { IoClose } from 'react-icons/io5';
import { LanguageContext } from '../../../../../../../../libs/Context';

const MutePopper = (props) =>
{
	const { language } = useContext(LanguageContext);
	const { open, handleClose, anchorEl } = props;

	return (
		<Popper
			open={open}
			id='simple-popper'
			anchorEl={anchorEl}
			placement='top'
			transition
			sx={{ zIndex: 99999 }}
			modifiers={[
				{
					name    : 'offset',
					options : {
						offset : [ 0, -12 ]
					}
				}
			]}
		>
			{({ TransitionProps }) => (
				<Fade {...TransitionProps} timeout={350}>
					<Box sx={{ borderRadius: '6px', p: 1, backgroundColor: 'white', border: '1px solid var(--grayE0)' }}>
						<Stack direction='row' spacing={2} justifyContent='center' alignItems='center'>
							<AiFillInfoCircle color='var(--primaryColor)' fontSize='var(--pixel24)' />
							<Typography>{language?.NotHearAnythg}</Typography>
							<Button
								size='small'
								variant='contained'
								sx={{
									color      : 'white',
									p          : 1,
									mr         : 1,
									width      : '88px',
									height     : '27px',
									fontSize   : 'var(--pixel12)',
									fontWeight : '400'
								}}
							>
								{language?.unmuteTxt}
							</Button>
							<Box sx={{ borderLeft: '1px solid #8D8A95', height: 'var(--pixel24)', mx: 1 }} />
							<IoClose color='var(--primaryColor)' onClick={handleClose} style={{ cursor: 'pointer' }} />
						</Stack>
					</Box>
				</Fade>
			)}
		</Popper>
	);
};

export default MutePopper;
